import React from 'react';
import { Image, Nav } from 'react-bootstrap';
import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <Nav.Link eventKey={2} onClick={toggleTheme}>
      <Image alt="image" 
        src={theme === 'light' ? '/images/lightMode.png' : '/images/darkMode.png'}
        width={20}
      />
    </Nav.Link>
  );
};

export default ThemeToggle;